module.exports = __webpack_public_path__ + "static/media/bg8.f4cab4bf.jpg";